export default "__VITE_ASSET__CTSrOofp__"